import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getReservationById } from "../../api/reservationApi";

const PAYUP_TEST_URL = "https://standard.testpayup.co.kr/assets/js/payup_standard_dev-1.0.js";
const PAYUP_PROD_URL = "https://standard.payup.co.kr/assets/js/payup_standard-1.0.js";
const IS_TEST_MODE = true; // true → 테스트, false → 운영
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api';

export default function Checkout() {
  const { reservationId } = useParams<{ reservationId: string }>();
  const [price, setPrice] = useState(50000);
  const [reservationData, setReservationData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // SDK 스크립트 로드 여부 추적용 ref
  const scriptLoaded = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    const scriptUrl = IS_TEST_MODE ? PAYUP_TEST_URL : PAYUP_PROD_URL;

    // window 전역에 로딩 여부 저장
  if ((window as any).__PAYUP_SDK_LOADED__) {
    return;
  }

  // DOM 상에도 중복 여부 체크 (정확하게 대비)
  if (document.querySelector(`script[src="${scriptUrl}"]`)) {
    (window as any).__PAYUP_SDK_LOADED__ = true;
    return;
  }

  const script = document.createElement("script");
  script.src = scriptUrl;
  script.async = true;
  script.onload = () => {
    (window as any).__PAYUP_SDK_LOADED__ = true;
  };
  script.onerror = () => {
    setError("PayUp SDK 로드 실패");
  };

  document.body.appendChild(script);
}, []);

  // 예약 데이터 불러오기
  useEffect(() => {
    const fetchReservation = async () => {
      try {
        if (reservationId) {
          const reservation = await getReservationById(Number(reservationId));
          setReservationData(reservation);
          setPrice(reservation.total_price);
        }
      } catch {
        setError("예약 데이터를 불러오는 데 실패했습니다.");
      } finally {
        setLoading(false);
      }
    };
    fetchReservation();
  }, [reservationId]);

  useEffect(() => {
    window.payupPaymentSubmit = function (payForm: HTMLFormElement) {
      payForm.action = `${API_BASE_URL}/payment/confirm`;
      payForm.submit();
    };

    window.payupPaymentClose = function (frm) {
      alert("결제가 취소되었습니다.");
      navigate('/spaces');
    };
    
  }, []);

  const handlePayment = () => {
    if (!reservationData) return;

    const { depositor, space, start_date, end_date, order_id } = reservationData;
    const orderName = `${space?.title} - ${start_date} ~ ${end_date}`;

    const paymentData = {
      merchantId: IS_TEST_MODE ? "standard_test" : "YOUR_MERCHANT_ID",
      itemName: orderName,
      amount: price.toString(),
      userName: depositor?.nickname || depositor?.name || "고객",
      orderNumber: order_id,
      returnUrl: `${API_BASE_URL}/payment/mobile`,
    };

    if (window.goPayupPay) {
      window.goPayupPay(paymentData);

      setTimeout(() => {
        const payupLayer = document.querySelector("#payup_layer");
      }, 500);
    } else {
      setError("PayUp SDK가 정상적으로 로드되지 않았습니다.");
    }
  };

  if (loading) return <div>로딩 중...</div>;
  if (error) return <div>{error}</div>;

  const { space, start_date, end_date, total_price } = reservationData;

  return (
    <div style={{ maxWidth: 600, margin: "0 auto", padding: "1rem" }}>
      <h1>예약 결제</h1>

      <div style={{ marginBottom: "1.5rem", padding: "1rem", border: "1px solid #ddd", borderRadius: 8 }}>
        <h2>예약 정보</h2>
        <p><strong>공간명:</strong> {space?.title}</p>
        <p><strong>주소:</strong> {space?.location}</p>
        <p><strong>보관 기간:</strong> {start_date} ~ {end_date}</p>
        <p><strong>결제 금액:</strong> {total_price?.toLocaleString()}원</p>
      </div>

      <div style={{ display: "flex", justifyContent: "center", marginTop: "2rem" }}>
        <button
          onClick={handlePayment}
          style={{
            padding: "0.8rem 1.6rem",
            fontSize: "1rem",
            backgroundColor: "#4F46E5",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
            cursor: "pointer",
            transition: "background-color 0.3s",
          }}
          onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#4338CA")}
          onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#4F46E5")}
        >
          결제하기
        </button>
      </div>
    </div>
  );
}
